import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IdentityOemMapping } from 'common/types/Entities';
import { DrawerEntitiesNames } from 'common/types/TypeDefs';

interface DeleteDialogState {
    isDialogOpen: boolean;
    currentEntityType?: DrawerEntitiesNames;
    currentEntity?: unknown;
    deleteCurrentTenantId?: string;
}

type StateWithDeleteDialog = { deleteDialog: DeleteDialogState };

const initialState: DeleteDialogState = {
    isDialogOpen: false,
};

const deleteDialogSlice = createSlice({
    name: 'deleteDialog',
    initialState,

    reducers: (create) => ({
        setDialogOpen: create.reducer((state, action: PayloadAction<boolean>) => {
            state.isDialogOpen = action.payload;
        }),

        setCurrentEntityType: create.reducer((state, action: PayloadAction<DrawerEntitiesNames | undefined>) => {
            state.currentEntityType = action.payload;
        }),

        setCurrentEntity: create.reducer((state, action: PayloadAction<IdentityOemMapping | null>) => {
            state.currentEntity = action.payload;
        }),

        setDeleteCurrentTenantId: create.reducer((state, action: PayloadAction<string>) => {
            state.deleteCurrentTenantId = action.payload;
        })
    })
});

// eslint-disable-next-line no-restricted-syntax
export default deleteDialogSlice.reducer;
export const selectIsDialogOpen = (state: StateWithDeleteDialog) => state.deleteDialog.isDialogOpen;
export const selectCurrentEntityType = (state: StateWithDeleteDialog) => state.deleteDialog.currentEntityType;
export const selectCurrentEntity = (state: StateWithDeleteDialog) => state.deleteDialog.currentEntity;
export const selectDeleteCurrentTenantId = (state: StateWithDeleteDialog) => state.deleteDialog.deleteCurrentTenantId;
export const { setDeleteCurrentTenantId, setDialogOpen, setCurrentEntity, setCurrentEntityType } = deleteDialogSlice.actions;
